import { render, staticRenderFns } from "./BattlesFilterSort.vue?vue&type=template&id=5605c82a&scoped=true"
import script from "./BattlesFilterSort.vue?vue&type=script&lang=js"
export * from "./BattlesFilterSort.vue?vue&type=script&lang=js"
import style0 from "./BattlesFilterSort.vue?vue&type=style&index=0&id=5605c82a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5605c82a",
  null
  
)

export default component.exports